module.exports = __webpack_public_path__ + "img/news-2.e6dbdbbf.jpg";